import { render } from "./AdrDatadogMonitor.vue?vue&type=template&id=1283cab7"
import script from "./AdrDatadogMonitor.vue?vue&type=script&lang=js"
export * from "./AdrDatadogMonitor.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__